var form_wizard = function (selector, rules, messages) {
    var wizard = $(selector);
    var form = wizard.closest('form');
    console.log("form wizard");
    console.log(form);

    var $validator = form_validator('#' + form.attr('id'), rules, messages);

    wizard.bootstrapWizard({
        'onNext': function (tab, navigation, index) {
            if (form.find(tab.find('a').attr('href') + ' input').length) {
                var $input_valid = form.find(tab.find('a').attr('href') + ' input').valid();
            } else {
                var $input_valid = true;
            }
            if (form.find(tab.find('a').attr('href') + ' select').length) {
                var $select_valid = form.find(tab.find('a').attr('href') + ' select').valid();
            } else {
                var $select_valid = true;
            }
            if (form.find(tab.find('a').attr('href') + ' textarea').length) {
                var $textarea_valid = form.find(tab.find('a').attr('href') + ' textarea').valid();
            } else {
                var $textarea_valid = true;
            }

            if (!($input_valid && $select_valid && $textarea_valid)) {
                $validator.focusInvalid();
                return false;
            } else {
                $(form.attr('id') + ' ' + 'a[href="#tab' + index + '"]').parent('li').removeClass('tab-current');
                $(form.attr('id') + ' ' + 'a[href="#tab' + (index + 1) + '"]').parent('li').addClass('tab-current');
                $(form.attr('id') + ' ' + '#tab' + index).removeClass('content-current active');
                $(form.attr('id') + ' ' + '#tab' + (index + 1)).addClass('content-current active');
                if(selector == "#app-campaigns-form-wizard")
                    $('html, body').animate({ scrollTop: 0 }, 'fast');
            }
        },
        'onPrevious': function (tab, navigation, index) {
            $(form.attr('id') + ' ' + 'a[href="#tab' + (index + 2) + '"]').parent('li').removeClass('tab-current');
            $(form.attr('id') + ' ' + 'a[href="#tab' + (index + 1) + '"]').parent('li').addClass('tab-current');
            $(form.attr('id') + ' ' + '#tab' + (index + 2)).removeClass('content-current active');
            $(form.attr('id') + ' ' + '#tab' + (index + 1)).addClass('content-current active');
            if(selector == "#app-campaigns-form-wizard")
                $('html, body').animate({ scrollTop: 0 }, 'fast');
        },
        'onTabClick': function (tab, navigation, index) {
            return false;
        },
        'onFinish': function (tab, navigation, index) {
            var $valid = form.valid();
            if (!$valid) {
                $validator.focusInvalid();
                return false;
            }
            else {
                console.log("submitform");
                form.submit();
            }
        },
        nextSelector: '.wizard-next',
        previousSelector: '.wizard-previous',
        firstSelector: '.wizard-first',
        finishSelector: '.wizard-finish'
    });
};